export default "__VITE_ASSET__BlfRT0CD__"